/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import IntegrationsfreshpaintFreshpaintIntegration from './IntegrationsfreshpaintFreshpaintIntegration';

/**
 * The IntegrationsFreshpaintBody model module.
 * @module model/IntegrationsFreshpaintBody
 * @version v0.3
 */
export default class IntegrationsFreshpaintBody {
  /**
   * Constructs a new <code>IntegrationsFreshpaintBody</code>.
   * @alias module:model/IntegrationsFreshpaintBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>IntegrationsFreshpaintBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/IntegrationsFreshpaintBody} obj Optional instance to populate.
   * @return {module:model/IntegrationsFreshpaintBody} The populated <code>IntegrationsFreshpaintBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new IntegrationsFreshpaintBody();
      if (data.hasOwnProperty('freshpaint_integration'))
        obj.freshpaintIntegration = IntegrationsfreshpaintFreshpaintIntegration.constructFromObject(data['freshpaint_integration']);
    }
    return obj;
  }
}

/**
 * @member {module:model/IntegrationsfreshpaintFreshpaintIntegration} freshpaintIntegration
 */
IntegrationsFreshpaintBody.prototype.freshpaintIntegration = undefined;

